export enum CustomerTabConfig {
  companyInfo = 0,
  opsContract = 1,
  saasContract = 2,
  customerConfiguration = 3,
  // Sits next to Configuration, so every index below it moved up by one. References go through
  // this enum by name, but a link that hardcoded a NUMBER (?tabIndex=4) now lands one tab over.
  shipmentConfiguration = 4,
  customerFinancial = 5,
  fleetConfiguration = 6,
  statements = 7,
  receivers = 8,
  myCustomers = 9,
  users = 10,
  transactions = 11,
}
